<mat-dialog-content>
    <div class="w-full pb-5">
        <h2 class="font-semibold text-lg">{{message}} </h2>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="pb-6">
    <button mat-raised-button class="bg-gray text-white" (click)="cancel()" tabindex="-1">{{cancelButtonText}}</button>
    <button mat-raised-button class="cnfText" (click)="confirm()" tabindex="-1" >{{confirmButtonText}}</button>
</mat-dialog-actions>   